import { isMiniApp, isWx } from './utils'

export const useRem = (
  usePcPage = !/android|iphone|linux|micromessenger/i.test(navigator.userAgent)
) => {
  var n = document.documentElement
  var MAXW = 476
  if (
    (/WindowsWechat/i.test(navigator.userAgent) ||
      /Macintosh/i.test(navigator.userAgent)) &&
    /MicroMessenger/i.test(navigator.userAgent) &&
    /wxwork/i.test(navigator.userAgent)
  ) {
    MAXW = 359
  }
  if (isMiniApp() && isWx('pc')) {
    MAXW = 414 // 兼容小程序pc端
  }
  function i() {
    var w = n.offsetWidth
    var e = w / 3.75
    var isMobile = /android|iphone/i.test(navigator.userAgent)
    var isOpenHarmony =
      navigator.userAgent.indexOf('OpenHarmony') > -1 &&
      navigator.userAgent.indexOf('Mobile') > -1
    if (!isMobile && !isOpenHarmony) {
      n.style.fontSize = MAXW / 3.75 + 'px'
      n.style.width = MAXW + 'px'
      n.style.margin = '0 auto'
    } else {
      const doc = document.documentElement || document.body
      const isHorizontal = doc.clientWidth > doc.clientHeight
      try {
        if (isHorizontal) {
          e = 100
        }
      } catch (err) {
        console.log(err)
      }
      n.style.fontSize = e + 'px'
      n.style.width = null
      n.style.margin = null
    }
  }
  function loaded() {
    document.body
      ? (document.body.style.fontSize = '14px')
      : document.addEventListener('DOMContentLoaded', loaded)
  }
  function removeLoaded() {
    document.removeEventListener('DOMContentLoaded', loaded)
  }
  function pageshow(e) {
    e.persisted && i()
  }
  function init() {
    removeLoaded()
    window.removeEventListener('resize', i)
    window.removeEventListener('pageshow', pageshow)
    if (usePcPage) {
      removeLoaded()
      n.style.fontSize = '100px'
      document.body.style.fontSize = '14px'
    } else {
      loaded()
      i()
      window.addEventListener('resize', i)
      window.addEventListener('pageshow', pageshow)
    }
  }
  init()
}
